import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { connect } from "react-redux";
import * as api from "../../api";
import {
  addServer,
  removeServerInvitation,
} from "../../store/actions/roomActions";

const ServerIcon = ({ name, iconUrl }) => (
  <Box
    sx={{
      width: "32px",
      height: "32px",
      borderRadius: "10px",
      bgcolor: "#f97316",
      backgroundImage: iconUrl ? `url("${iconUrl}")` : "none",
      backgroundSize: "cover",
      backgroundPosition: "center",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      fontWeight: 900,
      flex: "0 0 auto",
    }}
  >
    {!iconUrl && name.substring(0, 2).toUpperCase()}
  </Box>
);

const ServerInvitationItem = ({ invitation, addServer, removeServerInvitation }) => {
  const [disabled, setDisabled] = useState(false);
  const server = invitation.serverId || {};
  const serverName = server.name || "";
  const iconUrl = server.iconUrl || "";

  const handleAccept = async () => {
    setDisabled(true);
    const response = await api.acceptServerInvitation(invitation._id);
    if (!response.error) {
      addServer(response.data.server);
      removeServerInvitation(invitation._id);
      return;
    }
    setDisabled(false);
  };

  const handleReject = async () => {
    setDisabled(true);
    const response = await api.rejectServerInvitation(invitation._id);
    if (!response.error) {
      removeServerInvitation(invitation._id);
      return;
    }
    setDisabled(false);
  };

  return (
    <Box
      sx={{
        width: "calc(100% - 16px)",
        my: "6px",
        mx: "8px",
        p: "10px",
        borderRadius: "6px",
        bgcolor: "#24262b",
        border: "1px solid #3a2a1d",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <ServerIcon name={serverName} iconUrl={iconUrl} />
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ color: "#f2f3f5", fontSize: "14px", fontWeight: 800 }} noWrap>
            {serverName}
          </Typography>
          <Typography sx={{ color: "#b5bac1", fontSize: "12px" }} noWrap>
            приглашает {invitation.senderId?.displayName || invitation.senderId?.username}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", gap: "8px", mt: "10px" }}>
        <Button
          fullWidth
          disabled={disabled}
          onClick={handleAccept}
          sx={{
            bgcolor: "#f97316",
            color: "#fff",
            height: "30px",
            fontSize: "12px",
            fontWeight: 800,
            textTransform: "none",
            "&:hover": { bgcolor: "#ea580c" },
          }}
        >
          Принять
        </Button>
        <Button
          fullWidth
          disabled={disabled}
          onClick={handleReject}
          sx={{
            bgcolor: "#3a3c43",
            color: "#fff",
            height: "30px",
            fontSize: "12px",
            fontWeight: 800,
            textTransform: "none",
            "&:hover": { bgcolor: "#4e5058" },
          }}
        >
          Отклонить
        </Button>
      </Box>
    </Box>
  );
};

const ServerInvitationsList = ({ serverInvitations, addServer, removeServerInvitation }) => {
  if (!serverInvitations.length) {
    return (
      <Typography sx={{ color: "#8e9297", fontSize: "12px", px: "12px", py: "8px" }}>
        Нет приглашений на серверы
      </Typography>
    );
  }

  return (
    <Box sx={{ width: "100%", maxHeight: "240px", overflow: "auto" }}>
      <Box
        sx={{
          mx: "8px",
          my: "8px",
          px: "10px",
          py: "8px",
          borderRadius: "6px",
          bgcolor: "#4a2a10",
          color: "#fed7aa",
          fontSize: "12px",
          fontWeight: 800,
        }}
      >
        Новые приглашения: {serverInvitations.length}
      </Box>
      {serverInvitations.map((invitation) => (
        <ServerInvitationItem
          key={invitation._id}
          invitation={invitation}
          addServer={addServer}
          removeServerInvitation={removeServerInvitation}
        />
      ))}
    </Box>
  );
};

const mapStoreStateToProps = ({ room }) => ({
  serverInvitations: room.serverInvitations,
});

export default connect(mapStoreStateToProps, {
  addServer,
  removeServerInvitation,
})(ServerInvitationsList);
